import React from 'react';

import { withEventScope } from '@repo/event-processor';
import { buildWebsiteUrl } from '@repo/utils/url';

import ShowcaseContent from '../ShowcaseContent/ShowcaseContent';

import { AreYouSureContentProps } from './types';

const items = [
  {
    imgSrc: '/images/kittlAi.png',
    href: buildWebsiteUrl('/feature/kittl-ai'),
    heading: 'Kittl AI',
    description:
      'Current Kittl AI features are only just the beginning. There are new exciting innovations in the pipeline.',
  },
  {
    imgSrc: '/images/bgRemover.png',
    href: buildWebsiteUrl('/feature/ai-background-remover'),
    heading: 'Background Remover',
    description:
      'Ensure your images always stand out with clean, seamless edges.',
  },
  {
    imgSrc: '/images/mockups.png',
    href: buildWebsiteUrl('/tools/mockups'),
    heading: 'Mockup Generator',
    description:
      'Maintain that professional touch of showcasing your designs. They deserve the spotlight.',
  },
];

const AreYouSureContent: React.FC<AreYouSureContentProps> = ({
  subheading,
  primaryButton,
  secondaryButton,
}) => {
  return (
    <ShowcaseContent
      heading="Are you sure you have explored all that Kittl has to offer?"
      primaryButton={primaryButton}
      secondaryButton={secondaryButton}
      showcaseItems={items}
      subheading={subheading}
    />
  );
};

export default withEventScope(AreYouSureContent, {
  module: 'areYouSureContent',
});
